import { clientEnv } from "config"
import LogRocket from "logrocket"

if (clientEnv.isProduction && typeof window !== undefined) {
  LogRocket.init("we7skf/homeschool-boss")
}

export default LogRocket
